export const evidenceTypes = [
  {
    key: "screenshot",
    name: "截图证据",
    desc: "聊天记录、发文截图与后台页面的原图留存，保留发布时间与账号信息。",
    icon: "ri-image-line",
  },
  {
    key: "audio",
    name: "录音证据",
    desc: "通话与现场录音，附时长、录制环境与是否经过处理的说明。",
    icon: "ri-mic-line",
  },
  {
    key: "text",
    name: "文字记录",
    desc: "直播字幕稿、公开声明全文与逐字转录，标注删改位置。",
    icon: "ri-file-text-line",
  },
  {
    key: "video",
    name: "视频素材",
    desc: "现场录屏与片段回放，记录原始出处与可核对的完整版链接。",
    icon: "ri-video-line",
  },
  {
    key: "timeline",
    name: "时间线",
    desc: "把分散素材按发生顺序排好，专门用来对照前后说法是否一致。",
    icon: "ri-timeline-view",
  },
  {
    key: "party",
    name: "关联方",
    desc: "涉及账号、工作室与第三方知情者的交叉信息，标注关联依据。",
    icon: "ri-links-line",
  },
];